export default {
  badge: 'Test',
  badge_title: 'Restaurant de test',
  notice: 'Acesta este un restaurant de test. Comenzile plasate aici sunt pentru testare.',
};
